var map = {
	"./FishingStar.png": 64699,
	"./GreedyBoxImg.png": 480973,
	"./GreedyHiyaImg.png": 523245,
	"./GreedyProImg.png": 98007,
	"./GreedyRocket.png": 891457,
	"./RouletteImg.png": 512284,
	"./SlotsImg.png": 754117,
	"./TeenPatti.png": 405451
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 393200;